import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {CoreSettingsParameters, HARDWARE_ACCELERATION_DISABLED_MESSAGE, Settings, SlotSettingsParameters} from '@gongxigames/framework/slot';

export class CheckHardwareAccelerationAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        const {isWebGLHardwareAccelerated, desktop} = this.device;
        const skipHardwareAccelerationPopup = (this.settings as Settings<SlotSettingsParameters & CoreSettingsParameters>).get('skipHardwareAccelerationDisabledMessage');
        const showWarningMessage = !isWebGLHardwareAccelerated && !skipHardwareAccelerationPopup && desktop;

        if (showWarningMessage) {
            this.eventManager.emit('General.Message.SHOW', HARDWARE_ACCELERATION_DISABLED_MESSAGE);
        }
    }

    getName(): string {
        return 'CheckHardwareAccelerationAct';
    }
}